export default __webpack_public_path__ + "static/media/army_d.e38a7e69.png";